require('es6-promise').polyfill();
require("./cookie");
require("./discography");
require("./discography-filter-button");
require("./discography-filter-select");
require("./discography-album-modal");
require("./hero");
require("./hero-slider");
require("./article-list");
require("./article-featured");
require("./newsletter");
require("./instagram");
require("./story");